/**
 * Estratégia de ressuprimento do produto dentro da cotação.
 *
 * O valor bruto vem do backend em `replenishment_strategy`
 * (tbl_cotacao_produto.replenishment_strategy / tbl_produto.replenishment_strategy)
 * e é sempre uma das chaves abaixo. Produtos antigos, anteriores à criação da
 * coluna, podem chegar nulos — nesse caso não há tipo a exibir.
 */
export const REPLENISHMENT_LABELS = {
    CROSS: "Cross",
    DEPOSIT: "Depósito",
    DIRECT: "Direto",
};

/**
 * Rótulo legível da estratégia. Retorna o próprio valor bruto quando ele não
 * está mapeado (estratégia nova no backend ainda sem tradução aqui) e `null`
 * quando não há estratégia definida.
 *
 * @param {string|null|undefined} strategy
 * @returns {string|null}
 */
export const replenishmentLabel = (strategy) => {
    if (!strategy) return null;

    const key = String(strategy).trim().toUpperCase();

    return REPLENISHMENT_LABELS[key] || strategy;
};
